export default __webpack_public_path__ + "images/f5bf5a22f2ad94818202ed59f643499a-fundraising.webp";